
import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.min.css'
//import 'flatpickr/dist/themes/dark.css';
//import 'flatpickr/dist/themes/material_orange.css';



flatpickr(".datepicker_flatpickr", {

});

['turbo:load','turbo:frame-load','element_inserted'].forEach(function(e) {
 
  $(document).on(e, function() {
    $(".datepicker").flatpickr({
    
    });
  });

  $(document).on(e, function() {
    $(".datetimepicker").flatpickr({
        enableTime: true,
    });
  });

});
